import  { useEffect, useState } from 'react';

import FaqPage from './faq';
import { useGetCms, useGetRoad } from './api/api';
import { Footer } from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import AirdropAnimate from './Airdrop';
import {
    useAccount,
} from "wagmi";
import { useModalContext } from '../../contexts/ModalContext';
import SecurityAnime from './securityAnime';
import LowfeeAnime from './lowfeeAnime';
import EasyuseAnime from './easyuseAnime';
import Undermaintanence from '../Undermaintanence';
import { useICOStatus } from '../modals/api/api';
import HomeAd from '../ads/HomeAd';

const coinstructureBxList = [
    {
        color: '#2A42D9',
        val: '40%',
        shadow: 'linear-gradient(294deg, #2A42D9 17.44%, #081254 79.57%)'
    },
    {
        color: '#FF57BC',
        val: '20%',
        shadow: 'linear-gradient(109deg, #5F003F 14.84%, #FF57BC 83.32%)'
    },
    {
        color: '#C86AFF',
        val: '10%',
        shadow: 'linear-gradient(110deg, #784099 13.6%, #C86AFF 84.54%)'
    },
    {
        color: '#C19E2A',
        val: '10%',
        shadow: 'linear-gradient(295deg, #FFDC6A 20.5%, #998440 86.39%)'
    },
    {
        color: '#40AC86',
        val: '10%',
        shadow: 'linear-gradient(291deg, #6AFFCB 17.26%, #40997A 89.64%)'
    },
    {
        color: '#DC6F61',
        val: '10%',
        shadow: 'linear-gradient(291deg, #DC6F61 13.81%, #763C34 83.36%)'
    },
]

const coinStructValBxList = [
    {
        val: 'BSC',
        name: 'Blockchain Network'
    },
    {
        val: 'THE PILL',
        name: 'Token Name'
    },
    {
        val: '06 Digit',
        name: 'Decimals'
    },
    {
        val: 'TPL',
        name: 'Token Symbol'
    },
    {
        val: 'Yes',
        name: 'Burn Functions'
    },
    {
        val: '10,000,00M',
        name: 'Total Supply'
    }
]

const HomePage = () => {

    const { isConnected } = useAccount();

    const { data: Maintanence } = useICOStatus()
    const [siteMaintenance, setSiteMaintenance] = useState(false);

    const { data: getCms } = useGetCms()

 
    
    const { data: getHome } = useGetRoad()


    const { userDetails, modalConnectWallet, setModalConnectWallet } = useModalContext()
    
    const navigate = useNavigate()

 
    useEffect(() => {
        if (Maintanence?.data?.isMaintenance !== undefined) {
            setSiteMaintenance(Maintanence.data.isMaintenance);
        }
    }, [Maintanence]);

  

    const handleNavigation = () => {
        if (!isConnected) {
            setModalConnectWallet(!modalConnectWallet)
            return
        }
        if (userDetails?.data?.commissionDistributeStatus && userDetails?.data?.isEmailVerified) {
            navigate('/dashboard');
        } else if (userDetails?.data?.commissionDistributeStatus && !userDetails?.data?.isEmailVerified) {
            navigate('/profile-details');
        } else {
            navigate('/airdrop-deposit')
        }
    };

    return (
        <>
            <div className="mainContent">
                <div className="bannerMain">
                    <div className="homebanner">
                        <div className="container">
                            <div className='row justify-content-center'>
                                <div className="col-xl-9 col-lg-12">
                                    <div className="bannerContent">
                                        <h2>{getHome?.homePage[8]?.heading}</h2>
                                        <h1>{getHome?.homePage[8]?.title}</h1>
                                        <p>{getHome?.homePage[8]?.content}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='def-mt-140'>
                            <div className='bannerwaterMarkText'>INVESTMENT</div>
                            <div className='tokencenter'>
                                <div className='centerImg'>
                                    <img src={require('../../assets/images/home/tokenbannerCenter.png')} alt='tokenBanner' className='img-fluid tokencenterImg' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='botImghillrock'>
                        <div className='rockImg'>
                        </div>

                    </div>

                    <div className='mt-n55px text-center position-relative'>
                        <button className='btn btn-primary' onClick={handleNavigation}>Get Started</button>
                    </div>

                </div>
                <section className='secpad def-pt-35'>
                    <div className='container'>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="secHead text-center">
                                    <h4>Exploring THE PILL </h4>
                                    <h2>Earn Passive Income</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6">
                                <div className="epi-card airdropAnimeCard">
                                    <div className='cImg'>

                                    </div>
                                    <div className='chatAnimeSec airdropAnimeSec'>
                                        <AirdropAnimate />
                                    </div>
                                    <div className='cCont'>
                                        <div className='title'>

                                            {getHome?.homePage[5]?.title}
                                        </div>
                                        <div className='desc'>

                                            <p>{getHome?.homePage[5]?.content}</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="epi-card referralAnimeCard">
                                    <div className='cImg'>

                                    </div>
                                    <div className='chatAnimeSec referral'>
                                        <div className='referralChat-animation'>
                                            <div className='innermainChat'>
                                                <img src={require('../../assets/images/home/referralchat/referral-chart.png')} alt='referralchat' className='bgImg' />
                                            </div>
                                        </div>
                                        <img src={require('../../assets/images/home/referralchat/referral-icon.png')} alt='referral-icon' className='referralIcon iconimg1' />
                                        <img src={require('../../assets/images/home/referralchat/referral-icon.png')} alt='referral-icon' className='referralIcon iconimg2' />
                                        <img src={require('../../assets/images/home/referralchat/referral-icon.png')} alt='referral-icon' className='referralIcon iconimg3' />
                                        <div className='coinCenter'>
                                            <img src={require('../../assets/images/home/referralchat/referral-coin.png')} alt='referral-icon' className='referralcoin coinimg' />
                                        </div>
                                    </div>
                                    <div className='cCont'>
                                        <div className='title'>
                                            {getHome?.homePage[6]?.title}
                                        </div>
                                        <div className='desc'>
                                            <p>{getHome?.homePage[6]?.content} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="epi-card stakigchatCard">
                                    <div className='cImg'>

                                    </div>
                                    <div className='chatAnimeSec stakigchat'>
                                        <div className="stakingchat-animation">
                                            <div className='innermainchat'>
                                                <img src={require('../../assets/images/home/stakingchat/staking-right-chat.png')} alt='staking-right-chat' className='rightChat' />
                                            </div>
                                            <div className='innerleftTopchat'>
                                            </div>
                                        </div>
                                        <div className='jumbCoin'>
                                            <div className='coinCircle'>
                                                <img src={require('../../assets/images/home/stakingchat/coinImg.png')} alt='coinImg' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='cCont'>
                                        <div className='title'>
                                            {getHome?.homePage[7]?.title}

                                        </div>
                                        <div className='desc'>
                                            <p>{getHome?.homePage[7]?.content}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <section className='secpad'>
                    <div className='container'>
                        <div className='joincommunityBx'>
                            <div className="row">
                               
                                <div className="col-lg-5 order-1 order-lg-2">
                                    <div className="secHead">
                                        <h4>Our Values </h4>
                                        <h2 className='mb-2'>Join Community</h2>
                                        <div dangerouslySetInnerHTML={{ __html: getCms?.data[5]?.content }} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='secpad'>
                    <div className='container'>
                        <div className="row">
                            <div className="col-lg-5 align-self-center">
                                <div className="secHead">
                                    <h4>{getHome?.homePage[0]?.heading} </h4>
                                    <h2 className='mb-2'>{getHome?.homePage[0]?.title} </h2>
                                    <p>{getHome?.homePage[0]?.content}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className='rightDFSec'>
                                    <div className="row">
                                        <div className="col-md-auto">
                                            <div className="digitalFinanceCard securitycard">
                                                <div className='title px-3 text-center'>{getHome?.homePage[1]?.title}</div>
                                                <div className='desc px-3 text-center def-mb-15'>{getHome?.homePage[1]?.content}</div>
                                                <div className='dfImg mb-n4'>
                                                    <SecurityAnime />

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div className="digitalFinanceCard lowfeecard">
                                                <div className='d-flex'>
                                                    <div className='dfImg'>
                                                        <LowfeeAnime />

                                                    </div>
                                                    <div>
                                                        <div className='title'>{getHome?.homePage[2]?.title}</div>
                                                        <div className='desc pr-3'>{getHome?.homePage[2]?.content}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="digitalFinanceCard easytousecard">
                                                <div className='d-flex'>
                                                    <div className='dfImg'>
                                                        <EasyuseAnime />

                                                    </div>
                                                    <div>
                                                        <div className='title'>{getHome?.homePage[3]?.title}</div>
                                                        <div className='desc pr-3'>{getHome?.homePage[3]?.content}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='secpad'>
                    <div className='container'>
                        <div className="coinstructure">
                            <div className="row mb-4">
                                <div className="col-lg-4">
                                    <div className="secHead">
                                        <h4>{getHome?.homePage[4]?.heading} </h4>
                                        <h2 className='mb-2'>{getHome?.homePage[4]?.title}</h2>
                                        <p>{getHome?.homePage[4]?.content}</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 offset-lg-2">
                                    <div className="dashbordercard mt-3">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className='liquidypool'>
                                                    <span></span>
                                                    <label htmlFor="liquidity">Liquidity Pools</label>
                                                </div>
                                                <div className='playearn'>
                                                    <span></span>
                                                    <label htmlFor="Earn">Play to Earn</label>
                                                </div>
                                                <div className='airdropmarket'>
                                                    <span></span>
                                                    <label htmlFor="Airdrop">Airdrop & Marketing</label>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className='icooffer'>
                                                    <span></span>
                                                    <label htmlFor="ICO">ICO (initial Coin offering)</label>
                                                </div>
                                                <div className='stakeearn'>
                                                    <span></span>
                                                    <label htmlFor="Stake">Stake to Earn</label>
                                                </div>
                                                <div className='projectteam'>
                                                    <span></span>
                                                    <label htmlFor="Project">Project Team</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="coinstructureBx">
                                        {
                                            coinstructureBxList.map((grid) =>
                                                <div className="gridbx" style={{ '--bxColor': grid.color, '--shadowcolor': grid.shadow }} key={grid?._id}>
                                                    {grid.val}
                                                </div>
                                            )
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="px-lg-5">
                                <div className="row">
                                    {
                                        coinStructValBxList.map(({ val, name }, index) =>
                                            <div className="col-lg-4 col-md-6" key={val?._id}>
                                                <div className="coinstructValueBx" key={index + 'bx'}>
                                                    <div className="valueBx">{val}</div>
                                                    <div className='labelBx'>{name}</div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='secpad'>
                    <div className='container'>
                        <div className="row justify-content-center mb-5">
                            <div className="col-lg-6">
                                <div className="secHead text-center">
                                    <h4>FAQ </h4>
                                    <h2 className='mb-2'>{getCms?.data[3]?.title}</h2>
                                    <div dangerouslySetInnerHTML={{ __html: getCms?.data[3]?.content }} />

                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className='col-lg-10'>
                                <FaqPage />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Undermaintanence modalOpen={siteMaintenance} modalClose={() => setSiteMaintenance(!siteMaintenance)} />

            <Footer />
            <HomeAd />

        </>
    )
}

export default HomePage